<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Minha conta</p>
      </ion-grid>
      <div class="settings">
        <div class="settings-item-top mt-5 mb-0 cursor-pointer" @click="gotoChangeName">
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-1 bold dark text-md">Nome</p>
              <p class="mt-0 mb-0 thin dark text-sm">{{ profile.data.name }}</p>
            </ion-label>
            <ion-icon mode="ios" name="arrow-forward" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
        <div
          v-if="profile.data.provider !== 'google' && profile.data.provider !== 'facebook'"
          class="settings-item mt-0 mb-0 cursor-pointer"
          @click="gotoChangeEmail"
        >
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-1 bold dark text-md">Email</p>
              <p class="mt-0 mb-0 thin dark text-sm">{{ profile.data.email }}</p>
            </ion-label>
            <ion-icon mode="ios" name="arrow-forward" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
        <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoChangePhone">
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-1 bold dark text-md">Telefone</p>
              <p class="mt-0 mb-0 thin dark text-sm">{{ profile.data.phone }}</p>
            </ion-label>
            <ion-icon mode="ios" name="arrow-forward" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
        <div
          v-if="profile.data.provider !== 'google' && profile.data.provider !== 'facebook'"
          class="settings-item mt-0 mb-0 cursor-pointer"
          @click="gotoChangePassword"
        >
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-0 bold dark text-md">Alterar senha</p>
              <p class="mt-0 mb-0 thin dark text-sm d-flex-align-center">
                ······
                <ion-icon name="lock"></ion-icon>
              </p>
            </ion-label>
            <ion-icon mode="ios" name="arrow-forward" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
        <div class="settings-item mt-0 mb-0 cursor-pointer" @click="gotoSupport">
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-0 bold dark text-md">Suporte</p>
            </ion-label>
            <ion-icon mode="ios" name="help-circle-outline" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
        <div class="settings-item mt-0 mb-0 cursor-pointer" @click="logoutUser">
          <ion-item lines="none">
            <ion-label>
              <p class="mt-0 mb-0 bold dark text-md">Logout</p>
            </ion-label>
            <ion-icon mode="ios" name="exit" slot="end" class="dark"></ion-icon>
          </ion-item>
        </div>
      </div>
    </ion-content>
  </ion-app>
</template>

<script>
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// services
import authService from "@/services/auth/auth.js";
// component
export default {
  name: "UserSettings",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      platform: null,
      user: store.state.user,
      profile: store.state.profile
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.push({
        name: "Profile"
      });
    },
    gotoChangeName() {
      this.$router.push({
        name: "Change Name"
      });
    },
    gotoChangeEmail() {
      this.$router.push({
        name: "Change Email"
      });
    },
    gotoChangePhone() {
      this.$router.push({
        name: "Change Phone"
      });
    },
    gotoChangePassword() {
      this.$router.push({
        name: "Change Password"
      });
    },
    gotoSupport() {
      this.$router.push({
        name: "Support"
      });
    },
    async logoutUser() {
      await authService({
        action: "signout"
      });
      this.$router.push({
        name: "Login"
      });
    },
    async saveProfilePicture() {
      /*
      function base64toBlob(base64Data) {
        const contentType = "image/jpg";
        const sliceSize = 512;
        const byteCharacters = atob(base64Data);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          const begin = sliceIndex * sliceSize;
          const end = Math.min(begin + sliceSize, bytesLength);

          const bytes = new Array(end - begin);
          for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
      }
      const instance = this;
      let file;
      const userId = instance.user.uid;
      const info = await Device.getInfo();
      const platform = info.platform;
      if (platform === "ios" || platform === "android") {
        const rawFile = await takePicture();
        file = rawFile;
      } else {
        const rawFile = await takePicture();
        file = rawFile;
      }
      alert(file);
      if (userId && file) {
        const timestamp = Number(new Date());
        const storageRef = firebase
          .storage()
          .ref()
          .child(`users/${timestamp}`);
        storageRef
          .putString(file, "data_url")
          .then(snapshot => {
            if (snapshot) {
              snapshot.ref.getDownloadURL().then(function(downloadURL) {
                const ref = db
                  .collection("users")
                  .where("userId", "==", userId);
                ref
                  .get()
                  .then(snap => {
                    snap.forEach(doc => {
                      db.collection("users")
                        .doc(doc.id)
                        .update({
                          picture: downloadURL
                        })
                        .then(() => {
                          instance.profile.data.picture = downloadURL;
                          store.updateProfile(instance.profile);
                          instance.isLoading = false;
                        })
                        .catch(error => {
                          instance.isLoading = false;
                          instance.notification = {
                            class: "error-message p-3",
                            message:
                              "Ocorreu um erro ao processar essa operação. Tente novamente."
                          };
                          setTimeout(() => {
                            instance.clearNotification();
                          }, 3000);
                        });
                    });
                  })
                  .catch(error => {
                    instance.isLoading = false;
                    console.log(error);
                  });
              });
            } else {
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao processar essa operação. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            }
          })
          .catch(error => {
            instance.isLoading = false;
            instance.notification = {
              class: "error-message p-3",
              message:
                "Ocorreu um erro ao processar essa operação. Tente novamente."
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          });
      } else {
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message:
            "Ocorreu um erro ao processar essa operação. Tente novamente."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
      */
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
  }
};
</script>

<style scoped>
ion-app {
  background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    white
  ) !important;
}
ion-content {
  --padding-bottom: 50px;
  --background: transparent !important;
}
ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}
.avatar {
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
}
ion-avatar {
  position: relative;
  height: 100px;
  width: 100px;
  border: 2px solid white;
  box-shadow: 3px 12px 6px -3px rgba(0, 0, 0, 0.15);
}
.edit-picture {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 5px;
  right: -10px;
  z-index: 1000;
  width: 30px;
  height: 30px;
  border: 2px solid white;
  border-radius: 50%;
  background: var(--ion-color-primary);
  color: white;
  cursor: pointer !important;
}
.invisible-input {
  cursor: pointer !important;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.settings {
  position: absolute;
  bottom: 0;
  left: 0;
  max-height: 80vh;
  width: 100%;
  overflow-y: auto;
}
.settings-item-top {
  border-bottom: 1px solid #eeeeee;
}
.settings-item {
  border-bottom: 1px solid #eeeeee;
}
.health-item {
  --background: #666666 !important;
}
.health-item p {
  color: white !important;
}
.health-item ion-icon {
  color: white !important;
}
</style>
